"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Type = void 0;
const prelude_1 = require("@packages/prelude");
exports.Type = prelude_1.t.partial({
    buttonLabel: prelude_1.t.strict({
        btn_preview: prelude_1.t.string,
        btn_cta_view: prelude_1.t.string
    })
});
//# sourceMappingURL=ButtonLabel.js.map